import { motion } from "framer-motion"
import { useLanguage } from "../context/LanguageContext"
import { Link, useLocation, useNavigate } from "react-router-dom"
import linkedinIcon from "../assets/icons/linkedin.svg"
import facebookIcon from "../assets/icons/facebook.svg"
import instagramIcon from "../assets/icons/instagram.svg"
import saIcon from "../assets/icons/sa-flag.svg"
import usIcon from "../assets/icons/use-flag.svg"
import { fadeDown, staggerContainer } from "../lib/motion"

export function Header() {
  const { lang, setLang, translation: t } = useLanguage()
  const location = useLocation()
  const navigate = useNavigate()
  const articleBasePath = "/financial-wellness-tips-saudi-employees-2025/"

  const handleToggleLanguage = () => {
    const nextLang = lang === "en" ? "ar" : "en"
    setLang(nextLang)

    if (location.pathname.startsWith(articleBasePath)) {
      navigate(`${articleBasePath}${nextLang}`)
    }
  }

  return (
    <motion.header
      className="w-full pt-5 sm:py-5 px-6 md:px-0 md:pe-12 lg:pe-20 xl:pe-[5.625rem]"
      variants={fadeDown}
      initial="hidden"
      animate="show"
    >
        <motion.div
          className="flex items-center justify-between md:justify-end md:gap-[1.125rem] h-[1.875rem]"
          variants={staggerContainer(0.08, 0.05)}
          initial="hidden"
          animate="show"
        >
          {/* Hotline */}
          <motion.div className="text-primary" variants={fadeDown}>
            <span className="text-xs xs:text-sm sm:text-base">
              <span className="font-bold">{t.hotline} </span>
              <span className="font-normal">{t.phoneNumber}</span>
            </span>
          </motion.div>

          <motion.div className="w-px h-4 bg-separatorsColor self-center" variants={fadeDown} />
          {/* Social Icons */}  
          <motion.div variants={fadeDown}>
            <Link
              to="https://www.linkedin.com/company/nowpay/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-5 h-5 xs:w-6 xs:h-6 bg-white rounded flex items-center justify-center hover:bg-gray-100 transition-colors hover-scale"
              aria-label="LinkedIn"
            >
              <img src={linkedinIcon} alt="LinkedIn" />
            </Link>
          </motion.div>
          <motion.div variants={fadeDown}>
            <Link
              to="https://www.instagram.com/nowpayapp/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-5 h-5 xs:w-6 xs:h-6 bg-white rounded flex items-center justify-center hover:bg-gray-100 transition-colors hover-scale"
              aria-label="Instagram"
            >
              <img src={instagramIcon} alt="Instagram" />
            </Link>
          </motion.div>
          <motion.div variants={fadeDown}>
            <Link
              to="https://www.facebook.com/NowPayDotCash"
              target="_blank"
              rel="noopener noreferrer"
              className="w-5 h-5 xs:w-6 xs:h-6 bg-white rounded flex items-center justify-center hover:bg-gray-100 transition-colors hover-scale"
              aria-label="Facebook"
            >
              <img src={facebookIcon} alt="Facebook" />
            </Link>
          </motion.div>

          <motion.div className="w-px h-4 bg-separatorsColor self-center" variants={fadeDown} />
          {/* Language Switcher */}
          <motion.div variants={fadeDown} className="h-full flex items-center">
            <button onClick={handleToggleLanguage} className="hover-scale">
              <div className="flex items-center justify-center gap-1 md:gap-2">
                <span className="md:text-lg text-sm">
                  {lang === "en" ?
                    <img src={saIcon} alt="AR" className="w-3.5 h-2.5 xs:w-4 xs:h-3" /> : <img src={usIcon} alt="ENG" className="w-3.5 h-2.5 xs:w-4 xs:h-3" />}
                </span>
                <span className={`hidden md:block text-base font-normal text-primary ${lang === "en" ? "font-arabic" : ""}`}>
                  {lang === "en" ? "العربية" : "English"}
                </span>             
              </div>
            </button>
          </motion.div>
        </motion.div>
    </motion.header>
  )
}
